import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { Form } from 'react-bootstrap';
import DatePicker from 'react-datepicker';
import CustomDateInput from 'components/common/CustomDateInput';

const InputWeekStartDatePicker = ({
  column,
  displayName,
  selected,
  handleChange,
  useUTC = true,
  startOfWeek = 'monday'
}) => {
  const [tempDate, setTempDate] = useState('');
  const startDay = startOfWeek === 'monday' ? 1 : 0;

  useEffect(() => {
    let dateValue = selected;
    if (typeof selected === 'string' && selected) {
      dateValue = new Date(selected);
    }
    setTempDate(
      dateValue
        ? useUTC
          ? dateValue.toLocaleDateString('en-GB', { timeZone: 'UTC' })
          : dateValue.toLocaleDateString('en-GB')
        : ''
    );
  }, [selected, useUTC]);

  const handleDateChange = e => {
    const value = e.target.value;
    if (value === '') {
      setTempDate('');
      handleChange(column, undefined);
      return;
    }

    setTempDate(value);

    const dateRegex = /^\d{2}\/\d{2}\/\d{4}$/;
    if (!dateRegex.test(value)) return;

    const [dayStr, monthStr, yearStr] = value.split('/');
    const day = parseInt(dayStr, 10);
    const month = parseInt(monthStr, 10);
    const year = parseInt(yearStr, 10);

    const newDate = useUTC
      ? new Date(Date.UTC(year, month - 1, day))
      : new Date(year, month - 1, day);

    // Validate date
    if (
      newDate.getFullYear() === year &&
      newDate.getMonth() === month - 1 &&
      newDate.getDate() === day
    ) {
      if (newDate.getDay() === startDay) {
        handleChange(column, newDate);
      } else {
        setTempDate('');
        handleChange(column, undefined);
      }
    }
  };

  return (
    <Form.Group controlId={column}>
      {displayName && (
        <Form.Label style={{ marginBottom: 10 }}>{displayName}</Form.Label>
      )}
      <DatePicker
        selected={selected ? new Date(selected) : null}
        portalId="datepicker-root"
        onChange={newDate => {
          if (!newDate) {
            handleChange(column, undefined);
            setTempDate('');
            return;
          }

          const newDateFormatted = useUTC
            ? new Date(
                Date.UTC(
                  newDate.getFullYear(),
                  newDate.getMonth(),
                  newDate.getDate()
                )
              )
            : newDate;

          if (newDateFormatted.getDay() === startDay) {
            handleChange(column, newDateFormatted);
            setTempDate(newDateFormatted.toLocaleDateString('en-GB'));
          }
        }}
        filterDate={date => date.getDay() === startDay}
        customInput={
          <CustomDateInput
            formControlProps={{
              placeholder: 'dd/mm/yyyy',
              value: tempDate,
              onChange: handleDateChange
            }}
          />
        }
      />
    </Form.Group>
  );
};

InputWeekStartDatePicker.propTypes = {
  column: PropTypes.string.isRequired,
  displayName: PropTypes.string,
  selected: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.instanceOf(Date),
    PropTypes.object
  ]),
  handleChange: PropTypes.func,
  useUTC: PropTypes.bool,
  startOfWeek: PropTypes.oneOf(['monday', 'sunday'])
};

export default InputWeekStartDatePicker;
